import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ROUTES from "@/config/routes";

import { LOCALSTORAGE_KEYS } from "@/config";
import Login from "@/pages/login";
import ForgotPassword from "@/pages/ForgotPassword/ForgotPassword";
import RequireAuth from "@/components/RequireAuth";
import { useProtectedRoutes } from "./protectedRoutes";
import SetNewPassword from "@/pages/ForgotPassword/ResetPassword";

const AppRouter: React.FC = () => {
  const protectedRoutes = useProtectedRoutes();
  const token = localStorage.getItem(LOCALSTORAGE_KEYS.token);

  return (
    <Routes>
      <Route
        path={ROUTES.LOGIN}
        element={!token ? <Login /> : <Navigate to={ROUTES.DASHBOARD} />}
      />
      <Route
        path={ROUTES.HOME}
        element={
          token ? (
            <Navigate to={ROUTES.DASHBOARD} />
          ) : (
            <Navigate to={ROUTES.LOGIN} />
          )
        }
      />
      <Route path={ROUTES.FORGOTPASSWORD} element={<ForgotPassword />} />
      <Route path={ROUTES.RESETPASSWORD} element={<SetNewPassword />} />

      {/* Protected routes */}
      {protectedRoutes.map(({ path, element }) => (
        <Route
          key={path}
          path={path}
          element={<RequireAuth>{element}</RequireAuth>}
        />
      ))}
    </Routes>
  );
};

export default AppRouter;
